import { Component, EventEmitter, Input, Output } from '@angular/core';

export enum EInputType {
  TEXT = 'text',
  PASS = 'password',
  NUMBER = 'number',
  EMAIL = 'email',
  SEARCH = 'search',
  TEL = 'tel',
  URL = 'url',
  TIME = 'time',
  DNI = 'dni',
}

@Component({
  selector: 'sacyr-input',
  templateUrl: './sacyr-input.component.html',
  styleUrls: ['./sacyr-input.component.scss']
})
export class SacyrInputComponent {
  @Input() set setLabel(label: string) {
    this.label = label;
  }
  @Input() set setType(type: string) {
    this.typeOriginal = type;
    this.type = this.getSwitchType(type);
  }
  @Input() set setName(name: string) {
    this.name = name;
  }
  @Input() set setValue(value: string) {
    this.value = this.isNullOrEmpty(value) ? '' : value;
  }
  @Input() set setRequired(value: boolean) {
    this.required = value;
  }
  @Input() set setDisabled(value: boolean) {
    this.disabled = value;
  }
  @Input() set setReadOnly(value: boolean) {
    this.readonly = value;
  }
  @Input() set compareWith(value: string) {
    this.valueToCompare = value;
    this.hasErrors();
  }
  @Input() set setError(errorMessage: string) {
    this.inputErrorMessage = errorMessage;
    this.hasInputError = true;
  }

  @Output() outValue: EventEmitter<string> = new EventEmitter<string>();

  label: string;
  value: string = null;
  valueToCompare: string = null;
  private typeOriginal: string = EInputType.TEXT;
  type: EInputType = EInputType.TEXT;
  name = 'input' + this.type;
  hidePass: boolean = true;
  disabled = false;
  readonly = false;
  required = true;

  _firstLoad = true;

  // ERRORS
  inputErrorMessage = '';
  hasInputError = false;

  constructor() { }

  onInput($event: any): void {
    this.value = $event.currentTarget.value;
    this.hasErrors();
    this.onChange(this.value);
  }

  onClickEye() {
    this.hidePass = !this.hidePass;
    if (this.isInputPass()) {
      this.type = this.hidePass ? EInputType.PASS : EInputType.TEXT;
    }
  }

  isInputPass() {
    return this.typeOriginal === EInputType.PASS;
  }

  private onChange = (value) => { this.updateValue(value); };

  private updateValue(obj: any): void {
    this.value = obj;
    this.outValue.emit(this.value);
  }

  private getSwitchType(type: string) {
    let _type: EInputType;
    switch (type) {
      case EInputType.URL: _type = type; break;
      case EInputType.PASS: _type = type; break;
      case EInputType.NUMBER: _type = type; break;
      case EInputType.EMAIL: _type = type; break;
      case EInputType.SEARCH: _type = type; break;
      case EInputType.TEL: _type = type; break;
      case EInputType.URL: _type = type; break;
      case EInputType.TIME: _type = type; break;
      case EInputType.DNI:
      case EInputType.TEXT:
      default: _type = EInputType.TEXT; break;
    }
    return _type;
  }

  private hasErrors() {
    this.hasInputError = false;
    if (!this.isNullOrEmpty(this.value) && !this.isNullOrEmpty(this.valueToCompare)
      && this.isInputPass() && !this.isEqualTo()) {
      this.inputErrorMessage = `Las contraseñas no coinciden`;
      this.hasInputError = true;
    } else if (this.required && !this.disabled && this.isNullOrEmpty(this.value)) {
      this.inputErrorMessage = `Introduzca ${this.label.toLowerCase()}`;
      this.hasInputError = this._firstLoad ? false : true;
      this._firstLoad = false;
    }
    return this.hasInputError;
  }

  private isEqualTo() {
    return !this.isNullOrEmpty(this.value) && !this.isNullOrEmpty(this.valueToCompare)
      && this.value === this.valueToCompare;
  }

  private isNullOrEmpty(value: string) {
    return value === null || value === undefined || value === '';
  }
}